import type { CurrencyOption } from "./types";

export const stateStorageKey = "pyeah-state-v1";
export const setupDefaultsStorageKey = "pyeah-setup-defaults-v1";
export const themeModeStorageKey = "pyeah-theme-mode-v1";
export const selectedPotStorageKey = "pyeah-selected-pot-v1";
export const consentCookieName = "pyeah_storage_consent";
export const currencyCookieName = "pyeah_currency";
export const defaultPotName = "Default";

export const currencyOptions: CurrencyOption[] = [
  { locale: "en-GB", currency: "GBP", flag: "🇬🇧", label: "United Kingdom - GBP", shortLabel: "UK GBP" },
  { locale: "en-US", currency: "USD", flag: "🇺🇸", label: "United States - USD", shortLabel: "US USD" },
  { locale: "en-IE", currency: "EUR", flag: "🇮🇪", label: "Ireland - EUR", shortLabel: "IE EUR" },
  { locale: "fr-FR", currency: "EUR", flag: "🇫🇷", label: "France - EUR", shortLabel: "FR EUR" },
  { locale: "de-DE", currency: "EUR", flag: "🇩🇪", label: "Germany - EUR", shortLabel: "DE EUR" },
  { locale: "en-AU", currency: "AUD", flag: "🇦🇺", label: "Australia - AUD", shortLabel: "AU AUD" },
  { locale: "en-CA", currency: "CAD", flag: "🇨🇦", label: "Canada - CAD", shortLabel: "CA CAD" }
];
